import React from "react";

export default () => {
  return (
    <div className="label-content">
      <h4>Promotion 4GB Settings</h4>
    </div>
  );
};
